import api from '../../components/api'
import {
  LinkCostCodePayload,
  LinkCustomerPayload,
  PushCustomerPayload,
  QboAccount,
  QboCustomerRecord,
  QboItem,
} from './quickbooksModel'

// filterAssigned: only customers not yet linked to a SynkedUP customer.
// disableCache: read fresh from QuickBooks instead of the API's cache.
export const getQboCustomers = async (
  options: { filterAssigned?: boolean; disableCache?: boolean } = {}
): Promise<QboCustomerRecord[]> => {
  return (await api.get<QboCustomerRecord[]>('/quickbooks/customers', { params: options })).data
}

export const linkCustomerToQbo = async (payload: LinkCustomerPayload): Promise<void> => {
  await api.post('/customers/qbo', payload)
}

export const unlinkCustomerFromQbo = async (customerId: number): Promise<void> => {
  await api.post('/customers/qbo-unlink', customerId)
}

type PushCustomerResponse = {
  entity: {
    id: string
    displayName: string
  }
}

export const pushCustomerToQbo = async (payload: PushCustomerPayload): Promise<PushCustomerResponse> => {
  const propertyParam = payload.selectedPropertyId ? `&selectedPropertyId=${payload.selectedPropertyId}` : ''
  return (await api.post<PushCustomerResponse>(`/quickbooks/customer?id=${payload.customerId}${propertyParam}`)).data
}

export const getQboItems = async (): Promise<QboItem[]> => {
  return (await api.get<QboItem[]>('/quickbooks/items')).data
}

export const linkCostCodeToQbo = async (payload: LinkCostCodePayload): Promise<void> => {
  await api.post('/costcodes/qbo', payload)
}

export const getQboAccounts = async (): Promise<QboAccount[]> => {
  return (await api.get<QboAccount[]>('/quickbooks/accounts')).data
}
